import { props } from 'vue-prism-component';

export default [
  /*  Communications */
  {
    path: '/communications/:openChannelId?',
    name: 'Communications.Index',
    props: true,
    meta: {
      label: 'Communications Center',
      authorized: true
    },
    component: () => import('@/views/apps/communications/Index.vue')
  },
  {
    path: '/communications/view/:openChannelId?',
    name: 'Communications.Index2',
    props: true,
    meta: {
      label: 'Communications Center',
      authorized: true
    },
    component: () => import('@/views/apps/communications/Index.vue')
  },

  // Users & Invites
  {
    path: '/manage/users/list',
    name: 'Manage.Users.Index',
    component: () => import('@/views/apps/users/list/ListItems.vue'),
    meta: {
      permissionRequired: 'pm.teams.users.view'
    }
  },
  {
    path: '/user/my-account',
    name: 'user-my-account',
    component: () => import('@/views/apps/users/MyAccount.vue')
  },
  // Webhooks Log
  {
    path: '/log/webhooks',
    name: 'Manage.WebhooksLog.Index',
    component: () => import('@/views/apps/webhooks-log/list/ListItems.vue'),
    meta: {
      permissionRequired: 'pm.api.automation.webhooks.view'
    }
  },
  // R&D Manufacturing
  {
    path: '/rnd/projects/list',
    name: 'Manufacturing.RnDProjects.Index',
    component: () => import('@/views/apps/rndProjects/list/ListItems.vue'),
    meta: {
      permissionRequired: 'pm.manufacturing.rndProjects.view'
    }
  },
  {
    path: '/rnd/projects/view/:id',
    props: true,
    name: 'Manufacturing.RnDProjects.View',
    component: () => import('@/views/apps/rndProjects/view/Index.vue'),
    meta: {
      //permissionRequired: 'pm.customerBilling.invoices.view'
    }
  },
  // Invoices
  {
    path: '/customer-invoices/list',
    name: 'Manage.CustomerInvoices.Index',
    component: () => import('@/views/apps/customer-invoices/list/ListItems.vue'),
    meta: {
      permissionRequired: 'pm.customerBilling.invoices.view'
    }
  },
  // Automations
  {
    path: '/manage/automations/list',
    name: 'Other.Automation.Index',
    component: () => import('@/views/apps/automations/list/ListItems.vue'),
    meta: {
      permissionRequired: 'pm.automation.triggers'
    }
  },
  {
    path: '/manage/automations/create',
    name: 'Other.Automation.Create',
    component: () => import('@/views/apps/automations/create/Index.vue'),
    meta: {
      permissionRequired: 'pm.automation.triggers'
    }
  },
  {
    path: '/manage/automations/view/:id',
    name: 'Other.Automation.View',
    props: true,
    component: () => import('@/views/apps/automations/view/Index.vue'),
    meta: {
      permissionRequired: 'pm.automation.triggers'
    }
  },
  // Third-Party Integrations
  {
    path: '/manage/third-party-integrations/list',
    name: 'Integrations.ThirdParty.Index',
    component: () => import('@/views/apps/third-party-integrations/list/Index.vue'),
    meta: {
      permissionRequired: 'pm.integrations.orderSourceIntegrations.view'
    }
  },
  // Loop Returns install flow
  {
    path: '/integration/install/loopreturns',
    name: 'Integrations.LoopReturns.Install',
    component: () => import('@/views/apps/third-party-integrations/loop-returns/InstallPage.vue'),
    meta: {
      permissionRequired: 'pm.integrations.orderSourceIntegrations.edit'
    }
  },
  // Order Source Integrations
  {
    path: '/manage/order-source-integrations/list',
    name: 'Integrations.OrderSourceIntegrations.Index',
    component: () => import('@/views/apps/order-source-integrations/list/Index.vue'),
    meta: {
      permissionRequired: 'pm.integrations.orderSourceIntegrations.view'
    }
  },
  {
    path: '/manage/order-source-integrations/create',
    name: 'Integrations.OrderSourceIntegrations.Create',
    component: () => import('@/views/apps/order-source-integrations/create/Index.vue'),
    meta: {
      permissionRequired: 'pm.integrations.orderSourceIntegrations.edit'
    }
  },
  {
    path: '/manage/order-source-integrations/edit/:id',
    name: 'Integrations.OrderSourceIntegrations.Edit',
    props: true,
    component: () => import('@/views/apps/order-source-integrations/edit/Index.vue'),
    meta: {
      permissionRequired: 'pm.integrations.orderSourceIntegrations.edit'
    }
  },
  // Storefronts: Order Groups
  {
    path: '/manage/order-groups/list',
    name: 'Storefronts.OrderGroups.Index',
    component: () => import('@/views/apps/order-groups/list/Index.vue'),
    meta: {
      permissionRequired: 'pm.storefront.orderGroups.view'
    }
  },
  {
    path: '/manage/order-groups/edit/:id',
    props: true,
    name: 'Storefronts.OrderGroups.Edit',
    component: () => import('@/views/apps/order-groups/edit/Index.vue'),
    meta: {
      permissionRequired: 'pm.storefront.orderGroups.view'
    }
  },
  // Automations: Templates
  {
    path: '/manage/automationTemplates/list',
    name: 'Other.ContentTemplates.Index',
    component: () => import('@/views/apps/automationsContent/list/ListItems.vue'),
    meta: {
      permissionRequired: 'pm.storefronts.view'
    }
  },
  {
    path: '/manage/automationTemplates/create',
    name: 'Other.ContentTemplates.Create',
    component: () => import('@/views/apps/automationsContent/create/Index.vue'),
    meta: {
      permissionRequired: 'pm.automation.triggers'
    }
  },
  {
    path: '/manage/automationTemplates/view/:id',
    name: 'Other.ContentTemplates.View',
    props: true,
    component: () => import('@/views/apps/automationsContent/view/Index.vue'),
    meta: {
      permissionRequired: 'pm.automation.triggers'
    }
  },

  // Storefront Shipments
  {
    path: '/storefronts/shipments/list',
    name: 'Storefronts.Shipments.Index',
    component: () => import('@/views/apps/storefront-shipments/list/ListItems.vue'),
    meta: {
      permissionRequired: 'pm.orders.view'
    }
  },

  // SmallParcel Shipments
  {
    path: '/smallparcel-shipments/list',
    name: 'Warehouses.ManualShipments.Index',
    component: () => import('@/views/apps/smallparcel-shipments/list/ListItems.vue'),
    meta: {
      permissionRequired: 'pm.warehouses.bulkShipments.view'
    }
  },
  {
    path: '/smallparcel-shipments/create',
    name: 'Warehouses.ManualShipments.Create',
    component: () => import('@/views/apps/smallparcel-shipments/create/Index.vue'),
    meta: {
      permissionRequired: 'pm.warehouses.bulkShipments.request'
    }
  },
  {
    path: '/smallparcel-shipments/view/:id',
    name: 'Warehouses.ManualShipments.View',
    props: true,
    component: () => import('@/views/apps/smallparcel-shipments/view/Index.vue'),
    meta: {
      permissionRequired: 'pm.warehouses.bulkShipments.view'
    }
  },
  // Brands
  {
    path: '/my/brands/list',
    name: 'Manage.Brands.Index',
    component: () => import('@/views/apps/brands/list/ListItems.vue'),
    meta: {
      authorized: true
    }
  },
  {
    path: '/my/brands/edit-order-routing/:id',
    name: 'Manage.Brands.OrderRoutingConfig',
    props: true,
    component: () => import('@/views/apps/brands/orderRouting/Index.vue'),
    meta: {
      authorized: true
    }
  },
  {
    path: '/my/brands/edit/:id',
    name: 'Manage.Brands.Edit',
    props: true,
    component: () => import('@/views/apps/brands/edit/Index.vue'),
    meta: {
      authorized: true
    }
  },
  // Storefronts
  {
    path: '/my/storefronts/list',
    name: 'Manage.Storefronts.Index',
    component: () => import('@/views/apps/storefronts/list/ListItems.vue'),
    meta: {
      permissionRequired: 'pm.storefronts.view'
    }
  },
  {
    path: '/my/storefronts/create',
    name: 'Manage.Storefronts.Create',
    component: () => import('@/views/apps/storefronts/create/Index.vue'),
    meta: {
      permissionRequired: 'pm.storefronts.create'
    }
  },
  {
    path: '/my/storefronts/edit/:id',
    name: 'Manage.Storefronts.Edit',
    props: true,
    component: () => import('@/views/apps/storefronts/edit/Index.vue'),
    meta: {
      permissionRequired: 'pm.storefronts.edit'
    }
  },
  {
    path: '/my/storefronts/shopify-connected',
    name: 'Manage.Storefronts.ConfirmShopifyConnection',
    props: true,
    component: () => import('@/views/apps/storefronts/edit/ShopifyConfirm.vue'),
    meta: {
      permissionRequired: 'pm.storefronts.edit'
    }
  },
  {
    path: '/brightpearl/oauth/authorize',
    name: 'Manage.Storefronts.ConfirmBrightPearlConnection',
    props: true,
    component: () => import('@/views/apps/storefronts/edit/BrightPearlConfirm.vue'),
    meta: {
      permissionRequired: 'pm.storefronts.edit'
    }
  },
  // Ship Code Mappings
  {
    path: '/ship-codes/list',
    name: 'Storefronts.ShipCodes.Index',
    component: () => import('@/views/apps/ship-code-mappings/list/ListItems.vue'),
    meta: {
      authorized: true
    }
  },
  // Bulk Shipments
  {
    path: '/bulk-shipments/list',
    name: 'Warehouses.BulkShipments.Index',
    component: () => import('@/views/apps/bulk-shipments/list/ListItems.vue'),
    meta: {
      permissionRequired: 'pm.warehouses.bulkShipments.view'
    }
  },
  {
    path: '/bulk-shipments/create',
    name: 'Warehouses.BulkShipments.Create',
    component: () => import('@/views/apps/bulk-shipments/create/Index.vue'),
    meta: {
      permissionRequired: 'pm.warehouses.bulkShipments.request'
    }
  },
  {
    path: '/bulk-shipments/view/:id',
    name: 'Warehouses.BulkShipments.View',
    props: true,
    component: () => import('@/views/apps/bulk-shipments/view/Index.vue'),
    meta: {
      permissionRequired: 'pm.warehouses.bulkShipments.view'
    }
  },
  {
    path: '/bulk-shipments/edit/:id',
    name: 'Warehouses.BulkShipments.Edit',
    props: true,
    component: () => import('@/views/apps/bulk-shipments/update/Index.vue'),
    meta: {
      permissionRequired: 'pm.warehouses.bulkShipments.request'
    }
  },
  // ASNs
  {
    path: '/asns/list',
    name: 'Warehouses.AdvancedShipNotice.Index',
    component: () => import('@/views/apps/asns/list/ListItems.vue'),
    meta: {
      permissionRequired: 'pm.warehouses.asn.view'
    }
  },
  {
    path: '/asns/view/:id',
    name: 'Warehouses.AdvancedShipNotice.View',
    props: { default: true, isWT: false },
    component: () => import('@/views/apps/asns/view/Index.vue'),
    meta: {
      permissionRequired: 'pm.warehouses.asn.view'
    }
  },
  {
    path: '/asns/create',
    name: 'Warehouses.AdvancedShipNotice.Create',
    component: () => import('@/views/apps/asns/create/Index.vue'),
    meta: {
      permissionRequired: 'pm.warehouses.asn.create'
    }
  },
  // warehouse Transfers
  {
    path: '/warehouse-transfers/list',
    name: 'Warehouses.WarehouseTransfers.Index',
    component: () => import('@/views/apps/warehouse-transfers/list/ListItems.vue'),
    meta: {
      permissionRequired: 'pm.warehouses.wt.view'
    }
  },
  {
    path: '/warehouse-transfers/view/:id',
    name: 'Warehouses.WarehouseTransfers.View',
    props: { default: true, isWT: true },
    component: () => import('@/views/apps/warehouse-transfers/view/Index.vue'),
    meta: {
      permissionRequired: 'pm.warehouses.wt.view'
    }
  },
  {
    path: '/warehouse-transfers/create',
    name: 'Warehouses.WarehouseTransfers.Create',
    component: () => import('@/views/apps/warehouse-transfers/create/Index.vue'),
    meta: {
      permissionRequired: 'pm.warehouses.wt.create'
    }
  },
  {
    path: '/purchase-orders/list',
    name: 'Warehouses.PurchaseOrders.Index',
    component: () => import('@/views/apps/purchase-orders/list/ListItems.vue'),
    meta: {
      permissionRequired: 'pm.warehouses.purchaseOrders.view'
    }
  },
  {
    path: '/purchase-orders/:purchaseOrderId/create',
    name: 'Warehouses.PurchaseOrders.CreateShipment',
    props: true,
    component: () => import('@/views/apps/purchase-orders/create/Index.vue'),
    meta: {
      permissionRequired: 'pm.warehouses.asn.create'
    }
  },
  {
    path: '/purchase-orders/view/:id',
    name: 'Warehouses.PurchaseOrders.View',
    props: true,
    component: () => import('@/views/apps/purchase-orders/view/Index.vue'),
    meta: {
      permissionRequired: 'pm.warehouses.purchaseOrders.view'
    }
  },
  {
    path: '/purchase-orders/edit/:id',
    name: 'Warehouses.PurchaseOrders.Edit',
    props: true,
    component: () => import('@/views/apps/purchase-orders/form/Index.vue'),
    meta: {
      permissionRequired: 'pm.warehouses.purchaseOrders.edit'
    }
  },
  {
    path: '/purchase-orders/Create',
    name: 'Warehouses.PurchaseOrders.Create',
    component: () => import('@/views/apps/purchase-orders/form/Index.vue'),
    meta: {
      permissionRequired: 'pm.warehouses.purchaseOrders.create'
    }
  },

  {
    path: '/reports/stats/warehouse-items',
    name: 'apps-reports-warehouse-stats',
    component: () => import('@/views/apps/reports/wms-stats/list/ListItems.vue')
  },

  {
    path: '/reports/user-generated/create/:type',
    props: true,
    name: 'Reports.GeneratedReports.Create',
    component: () =>
      import('@/views/apps/reports/user-generated/create/Index.vue'),
      meta: {
        permissionRequired: 'pm.reports.storefrontProdStats'
      }
  },
  {
    path: '/reports/user-generated/view/:id',
    props: true,
    name: 'Reports.GeneratedReports.View',
    component: () =>
      import('@/views/apps/reports/user-generated/view/Index.vue'),
      meta: {
        permissionRequired: 'pm.reports.storefrontProdStats'
      }
  },
  {
    path: '/reports/user-generated/:type',
    props: true,
    name: 'Reports.GeneratedReports.Index',
    component: () =>
      import('@/views/apps/reports/user-generated/list/Index.vue'),
      meta: {
        permissionRequired: 'pm.reports.storefrontProdStats'
      }
  },
  {
    path: '/reports/stats/storefront-products',
    name: 'apps-reports-storefront-stats',
    component: () =>
      import('@/views/apps/reports/storefront-stats/list/ListItems.vue'),
      meta: {
        permissionRequired: 'pm.reports.storefrontProdStats'
      }
  },

  {
    path: '/warehouse-items/list',
    name: 'Warehouses.Items',//'apps-inventory-items-list',
    component: () => import('@/views/apps/warehouse-items/list/ListItems.vue'),
    meta: {
      permissionRequired: 'pm.warehouses.items.view'
    }
  },
  {
    path: '/warehouse-items/byLocation/list',
    name: 'Warehouses.Items.Locations',//'apps-inventory-items-list',
    component: () => import('@/views/apps/warehouse-items/list/ListItemsByLocation.vue'),
    meta: {
      permissionRequired: 'pm.warehouses.items.viewInventoryByLocation'
    }
  },
  {
    path: '/warehouse-items/item/:id',
    props: true,
    name: 'Warehouses.Items.Form',
    component: () => import('@/views/apps/warehouse-items/view/Index.vue'),
    meta: {
      permissionRequired: 'pm.warehouses.items.view'
    }
  },
  // Orders
  {
    path: '/customer-orders/import',
    name: 'Orders.Index.Import',
    component: () => import('@/views/apps/customer-orders/create/Import.vue'),
    meta: {
      permissionRequired: 'pm.orders.view'
    }
  },
  {
    path: '/customer-orders/list-all',
    name: 'Orders.Index.All',
    component: () => import('@/views/apps/customer-orders/list/ListItems.vue'),
    meta: {
      permissionRequired: 'pm.orders.view'
    }
  },
  {
    path: '/customer-orders',
    name: 'Orders.Index.Main',
    component: () => import('@/views/apps/customer-orders/list/ListItems.vue'),
    meta: {
      permissionRequired: 'pm.orders.view'
    }
  },
  {
    path: '/customer-orders/list',
    name: 'Orders.Index',
    component: () => import('@/views/apps/customer-orders/list/ListItems.vue'),
    meta: {
      permissionRequired: 'pm.orders.view'
    }
  },
  {
    path: '/customer-orders/list',
    name: 'Orders.Index.Filtered',
    component: () => import('@/views/apps/customer-orders/list/ListItems.vue'),
    meta: {
      permissionRequired: 'pm.orders.view'
    }
  },
  {
    path: '/customer-orders/returns',
    name: 'Storefronts.OrderReturns.Index',
    props: { default: true, splitRecs: true },
    component: () => import('@/views/apps/customer-orders/returns/ListItems.vue'),
    meta: {
      permissionRequired: 'pm.orderReturns.view'
    }
  },
  {
    path: '/customer-orders/returns/view/:orderReturnId?',
    name: 'Storefronts.OrderReturns.Edit',
    props: true,
    component: () => import('@/views/apps/customer-orders/returns/Form.vue'),
    meta: {
      permissionRequired: 'pm.orderReturns.view'
    }
  },
  {
    path: '/customer-orders/list/unhold-recs',
    name: 'Orders.Index.UnholdRecs',
    props: { default: true, splitRecs: false, unholdRecs: true },
    component: () => import('@/views/apps/customer-orders/list/ListItems.vue'),
    meta: {
      permissionRequired: 'pm.orders.splitOrder'
    }
  },
  {
    path: '/customer-orders/list/split-recs',
    name: 'Orders.Index.SplitRecs',
    props: { default: true, splitRecs: true },
    component: () => import('@/views/apps/customer-orders/list/ListItems.vue'),
    meta: {
      permissionRequired: 'pm.orders.splitOrder'
    }
  },

  {
    path: '/customer-orders/view',
    name: 'apps-customer-orders-view',
    component: () => import('@/views/apps/customer-orders/view/Index.vue'),
    meta: {
      permissionRequired: 'pm.orders.view'
    }
  },
  {
    path: '/customer-orders/view',
    name: 'Common.OrderDetails',
    component: () => import('@/views/apps/customer-orders/view/Index.vue'),
    meta: {
      permissionRequired: 'pm.orders.view'
    }
  },
  {
    path: '/customer-orders/create',
    name: 'apps-customer-orders-create',
    component: () => import('@/views/apps/customer-orders/create/Index.vue'),
    meta: {
      permissionRequired: 'pm.orders.create'
    }
  },

  {
    path: '/docs',
    name: 'DocsHome',
    meta: {
      label: 'Docs',
      authorized: true
    },
    component: () => {
      return import(
        /* webpackChunkName: "DocsHome" */ '@/views/apps/other/DocsHome'
      );
    }
  },
  {
    path: '/docs/article/:slug',
    name: 'ViewKnowledgeArticle',
    props: true,
    meta: {
      label: 'Docs Article',
      authorized: true
    },
    component: () => {
      return import(
        /* webpackChunkName: "ViewKnowledgeArticle" */ '@/views/apps/other/ViewKnowledgeArticle'
      );
    }
  },
  {
    path: '/docs/group/:slug',
    name: 'ViewKnowledgeGroup',
    props: true,
    meta: {
      label: 'Article Group',
      authorized: true
    },
    component: () => {
      return import(
        /* webpackChunkName: "ViewKnowledgeGroup" */ '@/views/apps/other/ViewKnowledgeGroup'
      );
    }
  },
];
